<template>
    <div class="similar-column-wrapper">
        <el-link @click="clickHandler">{{ this.row.similarQuestion }}</el-link>
        <span v-if="row.addData.recommendSimilar" class="i-recommend" @click.stop.self="recommendClick(row.addData)">{{
            $t("zhiji.knowlege.recommendText")
        }}</span>
    </div>
</template>

<script>
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal.vue"

export default {
    name: "SimilarColumn",
    props: ["data", "row"],
    computed: {
        tips() {
            return this.row.addData.similarQuestion.tips;
        }
    },
    methods: {
        clickHandler() {
            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    questionId: this.row.questionId,
                    sceneId: this.row.addData.sceneId,
                    curPanel: "SimilarPanel",
                    currentTab: "ExistingSimilars",
                    hasRecommendSimilar: this.row.addData.recommendSimilar
                }
            });
        },
        recommendClick(data) {
            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    questionId: data.rowId,
                    sceneId: data.sceneId,
                    curPanel: "SimilarPanel",
                    currentTab: "RecommendSimilars",
                    hasRecommendSimilar: data.recommendSimilar,
                    closeHandler: () => {
                        this.$store.dispatch("queryQuestionList", {});
                        this.$store.dispatch("queryExtQuestionTotal", {});
                        this.$store.dispatch("queryAnswersTotal", {});
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.similar-column-wrapper {
    display: flex;
    justify-content: space-between;
    max-width: 90px;
    box-sizing: border-box;

    .link {
        position: relative;

        &:hover {
            cursor: pointer;
            color: #2ec2ff;
            text-decoration: underline;

            .link-tip {
                display: inline-block;
            }
        }

        .link-tip {
            display: none;
        }
    }
    /deep/ .el-link--inner {
        font-size: 12px;
    }
    .i-recommend {
        cursor: pointer;
        padding: 2px 6px;
        font-size: 12px;
        color: #fff;
        background: #a4a4f7;
        box-shadow: 0 2px 6px 0 rgba(164, 164, 247, 0.3);
        border-radius: 4px;
        white-space: nowrap;
    }
}
</style>
